import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IActivitySchedule } from 'app/shared/model/activity-schedule.model';
import { getEntities as getActivitySchedules } from 'app/entities/activity-schedule/activity-schedule.reducer';
import { IWeekDayTime } from 'app/shared/model/week-day-time.model';
import { WeekDay } from 'app/shared/model/enumerations/week-day.model';
import { getEntity, updateEntity, createEntity, reset } from './week-day-time.reducer';

export const WeekDayTimeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const activitySchedules = useAppSelector(state => state.activitySchedule.entities);
  const weekDayTimeEntity = useAppSelector(state => state.weekDayTime.entity);
  const loading = useAppSelector(state => state.weekDayTime.loading);
  const updating = useAppSelector(state => state.weekDayTime.updating);
  const updateSuccess = useAppSelector(state => state.weekDayTime.updateSuccess);
  const weekDayValues = Object.keys(WeekDay);

  const handleClose = () => {
    navigate('/week-day-time' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getActivitySchedules({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...weekDayTimeEntity,
      ...values,
      activitySchedule: activitySchedules.find(it => it.id.toString() === values.activitySchedule.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          weekDay: 'SUNDAY',
          ...weekDayTimeEntity,
          activitySchedule: weekDayTimeEntity?.activitySchedule?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.weekDayTime.home.createOrEditLabel" data-cy="WeekDayTimeCreateUpdateHeading">
            <Translate contentKey="activitiesApp.weekDayTime.home.createOrEditLabel">Create or edit a WeekDayTime</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="week-day-time-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.weekDay')}
                id="week-day-time-weekDay"
                name="weekDay"
                data-cy="weekDay"
                type="select"
              >
                {weekDayValues.map(weekDay => (
                  <option value={weekDay} key={weekDay}>
                    {translate('activitiesApp.WeekDay.' + weekDay)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.fromTime24H')}
                id="week-day-time-fromTime24H"
                name="fromTime24H"
                data-cy="fromTime24H"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.toTime24H')}
                id="week-day-time-toTime24H"
                name="toTime24H"
                data-cy="toTime24H"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.duration')}
                id="week-day-time-duration"
                name="duration"
                data-cy="duration"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.adultCount')}
                id="week-day-time-adultCount"
                name="adultCount"
                data-cy="adultCount"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.childCount')}
                id="week-day-time-childCount"
                name="childCount"
                data-cy="childCount"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTime.infantCount')}
                id="week-day-time-infantCount"
                name="infantCount"
                data-cy="infantCount"
                type="text"
              />
              <ValidatedField
                id="week-day-time-activitySchedule"
                name="activitySchedule"
                data-cy="activitySchedule"
                label={translate('activitiesApp.weekDayTime.activitySchedule')}
                type="select"
              >
                <option value="" key="0" />
                {activitySchedules
                  ? activitySchedules.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.scheduleName}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/week-day-time" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WeekDayTimeUpdate;
